function getCurrencySymbol() {
  const priceEl = document.querySelector('[data-product-price]') || document.querySelector('.price-item--regular');
  if (!priceEl) return 'RM';
  const match = priceEl.textContent.trim().match(/^[^\d]+/);
  return match ? match[0].trim() : 'RM';
}

function getBasePriceFromPage() {
  const priceEl = document.querySelector('[data-product-price]') || document.querySelector('.price-item--regular');
  if (!priceEl) return 0;
  const priceText = priceEl.textContent.replace(/[^0-9.]/g, '');
  return parseFloat(priceText) || 0;
}

function getMinSqft() {
  const minSqftEl = document.getElementById('min-sqft');
  return minSqftEl ? parseInt(minSqftEl.value) || 0 : 0;
}

// Convert any unit to feet
function convertToFeet(value, unit) {
  if (!value || isNaN(value)) return 0;
  
  switch(unit) {
    case 'ft':
      return parseFloat(value);
    case 'cm':
      return parseFloat(value) / 30.48; // 1 ft = 30.48 cm
    case 'inch':
      return parseFloat(value) / 12; // 1 ft = 12 inch
    default:
      return parseFloat(value);
  }
}

// Format display size based on original unit
function formatSizeDisplay(width, height, unit) {
  const widthValue = parseFloat(width);
  const heightValue = parseFloat(height);
  
  return `W${widthValue} × H${heightValue} ${unit}`;
}

// Format conversion display
function formatConversionDisplay(widthFt, heightFt, unit) {
  const widthValue = parseFloat(document.getElementById('inside-width').value || document.getElementById('outside-width').value);
  const heightValue = parseFloat(document.getElementById('inside-height').value || document.getElementById('outside-height').value);
  
  let display = '';
  
  if (unit !== 'ft') {
    display += `Width: ${widthValue}${unit} = ${widthFt.toFixed(2)}ft`;
    display += ' | ';
    display += `Height: ${heightValue}${unit} = ${heightFt.toFixed(2)}ft`;
  }
  
  return display;
}

// Update unit displays
function updateUnitDisplays(unit) {
  const unitText = unit === 'ft' ? 'ft' : unit === 'cm' ? 'cm' : 'inch';
  
  // Update inside section
  document.getElementById('inside-width-unit-display').textContent = unitText;
  document.getElementById('inside-height-unit-display').textContent = unitText;
  
  // Update outside section
  document.getElementById('outside-width-unit-display').textContent = unitText;
  document.getElementById('outside-height-unit-display').textContent = unitText;
}

// Show/hide minimum order notice based on calculated sqft
function toggleMinOrderNotice(calculatedSqft) {
  const minSqft = getMinSqft();
  const minOrderNotice = document.getElementById('min-order-notice');
  
  if (minOrderNotice && minSqft > 0) {
    if (calculatedSqft >= minSqft) {
      minOrderNotice.style.display = 'none';
    } else {
      minOrderNotice.style.display = 'block';
    }
  }
}

function initCustomBlindsCalculator() {
  const initializationTarget = document.getElementById('custom-type');
  const initialCalculator = document.querySelector('.blinds-calculator');

  if (!initializationTarget || !initialCalculator) return;
  if (initializationTarget.dataset.customBlindsInitialized === 'true') return;
  initializationTarget.dataset.customBlindsInitialized = 'true';

  // Helper: get variant description
  function getVariantDescription() {
    let variantDesc = [];

    // Method 7: Check for any active variant elements
    const activeVariants = document.querySelectorAll('[data-option-index] input:checked, .product-form__input input:checked');
    activeVariants.forEach(variant => {
      const value = variant.value || variant.getAttribute("data-value");
      if (value && value.trim()) variantDesc.push(value.trim());
    });

    return variantDesc.length > 0 ? variantDesc.join(" / ") : "";
  }

  // Main elements
  const customTypeEl = document.getElementById("custom-type");
  const blindsCalculator = document.querySelector(".blinds-calculator");
  const calculatorContent = document.getElementById("calculator-content");
  const insideSection = document.getElementById("inside-section");
  const outsideSection = document.getElementById("outside-section");
  const mountTypeGuide = document.getElementById("mount-type-guide");
  const insideGuide = document.getElementById("inside-guide");
  const outsideGuide = document.getElementById("outside-guide");
  const commonUnitEl = document.getElementById("common-unit");

  function currentProductInfoScope() {
    const currentCalculator = document.querySelector('.blinds-calculator');
    return currentCalculator?.closest('[id^="ProductInfo-"]') || document;
  }

  function selectedVariantIsAvailable() {
    const currentScope = currentProductInfoScope();
    const liveVariantIdInput = currentScope.querySelector('form[action*="/cart/add"] input[name="id"], input[name="id"]');
    const variantDataNode = document.getElementById('custom-blinds-variants-json');

    if (liveVariantIdInput && variantDataNode) {
      try {
        const variants = JSON.parse(variantDataNode.textContent || '[]');
        const selectedVariant = variants.find(variant =>
          String(variant.id) === String(liveVariantIdInput.value)
        );

        if (selectedVariant) return selectedVariant.available === true;
      } catch (error) {
        console.warn('Unable to read custom blinds variant availability.', error);
      }
    }

    // Fallback for themes that do not expose the selected variant ID.
    const selectedVariantInputs = currentScope.querySelectorAll(
      '.product-form__input input:checked, [data-option-index] input:checked'
    );

    // Do not block products whose theme does not use selectable variant inputs.
    if (!selectedVariantInputs.length) return true;

    return !Array.from(selectedVariantInputs).some(input => {
      const labels = Array.from(input.labels || []);
      const inputHasUnavailableClass = Array.from(input.classList).some(className =>
        className.toLowerCase().includes('disabled')
      );
      const labelHasUnavailableClass = labels.some(label =>
        Array.from(label.classList).some(className =>
          className.toLowerCase().includes('disabled')
        )
      );

      return input.disabled ||
        input.getAttribute('aria-disabled') === 'true' ||
        inputHasUnavailableClass ||
        labelHasUnavailableClass;
    });
  }

  function syncCalculatorVisibility() {
    const currentCalculator = document.querySelector('.blinds-calculator');
    const currentCalculatorContent = document.getElementById('calculator-content');
    const currentMountTypeGuide = document.getElementById('mount-type-guide');
    const currentInsideSection = document.getElementById('inside-section');
    const currentOutsideSection = document.getElementById('outside-section');
    const currentInsideGuide = document.getElementById('inside-guide');
    const currentOutsideGuide = document.getElementById('outside-guide');
    const currentCustomType = document.getElementById('custom-type');
    const selectedMountType = currentCustomType?.value || '';
    const hasMountType = selectedMountType === 'inside' || selectedMountType === 'outside';

    if (!currentCalculator || !currentCalculatorContent || !currentMountTypeGuide) return;

    if (hasMountType) {
      currentMountTypeGuide.style.display = 'block';
      currentCalculator.style.display = 'block';
      currentCalculatorContent.style.display = 'block';
      if (currentInsideSection) currentInsideSection.style.display = selectedMountType === 'inside' ? 'block' : 'none';
      if (currentOutsideSection) currentOutsideSection.style.display = selectedMountType === 'outside' ? 'block' : 'none';
      if (currentInsideGuide) currentInsideGuide.style.display = selectedMountType === 'inside' ? 'block' : 'none';
      if (currentOutsideGuide) currentOutsideGuide.style.display = selectedMountType === 'outside' ? 'block' : 'none';
    } else {
      currentMountTypeGuide.style.display = 'none';
      currentCalculator.style.display = 'none';
      currentCalculatorContent.style.display = 'none';
    }
  }

  function setVariantError(message) {
    const errorMessage = document.getElementById('variant-error-message');
    if (!errorMessage) return;

    errorMessage.textContent = message || '';
    errorMessage.hidden = !message;
  }

  // Common unit change handler
  commonUnitEl.addEventListener("change", function() {
    const selectedUnit = this.value;
    updateUnitDisplays(selectedUnit);
    calculateBlinds();
  });

  // Main event listener for custom type selection
  customTypeEl.addEventListener("change", function () {
    syncCalculatorVisibility();
    calculateBlinds();
  });

  // Unit conversion and calculation functions
  function updateConversionDisplay() {
    const customType = document.getElementById("custom-type").value;
    const commonUnit = document.getElementById("common-unit").value;
    
    let widthInput, heightInput, conversionEl;
    
    if (customType === "inside") {
      widthInput = document.getElementById("inside-width");
      heightInput = document.getElementById("inside-height");
      conversionEl = document.getElementById("inside-conversion");
    } else {
      widthInput = document.getElementById("outside-width");
      heightInput = document.getElementById("outside-height");
      conversionEl = document.getElementById("outside-conversion");
    }
    
    if (widthInput && heightInput && conversionEl) {
      const widthFt = convertToFeet(widthInput.value, commonUnit);
      const heightFt = convertToFeet(heightInput.value, commonUnit);
      
      const conversionText = formatConversionDisplay(widthFt, heightFt, commonUnit);
      conversionEl.textContent = conversionText;
    }
  }

  // Calculate blinds price - FIXED VERSION
  function calculateBlinds() {
    if (!validateBlindsFields()) return;
    
    const currency = getCurrencySymbol();
    const basePrice = getBasePriceFromPage();
    const minSqft = getMinSqft();
    const customType = document.getElementById("custom-type").value;
    const qty = parseInt(document.getElementById('blinds-qty')?.value || 1);
    const commonUnit = document.getElementById("common-unit").value;

    document.getElementById("currency-symbol").textContent = currency;
    document.getElementById("currency-symbol-subtotal").textContent = currency;

    let widthInput, heightInput;
    
    if (customType === "inside") {
      widthInput = document.getElementById("inside-width");
      heightInput = document.getElementById("inside-height");
    } else {
      widthInput = document.getElementById("outside-width");
      heightInput = document.getElementById("outside-height");
    }

    const width = parseFloat(widthInput.value) || 0;
    const height = parseFloat(heightInput.value) || 0;
    
    if (width <= 0 || height <= 0) {
      document.getElementById("blinds-size-row").style.display = "none";
      document.getElementById("blinds-sqft").textContent = "0.00";
      document.getElementById("blinds-total").textContent = "0.00";
      document.getElementById("blinds-subtotal").textContent = "0.00";
      return;
    }

    // Convert to feet for calculation
    const widthFt = convertToFeet(width, commonUnit);
    const heightFt = convertToFeet(height, commonUnit);
    
    // Calculate square footage
    let sqft = widthFt * heightFt;
    const calculatedSqft = sqft;
    
    // Apply minimum sqft if applicable
    if (minSqft > 0 && sqft < minSqft) {
      sqft = minSqft;
    }
    
    // Calculate prices - FIXED ROUNDING LOGIC
    const pricePerSet = sqft * basePrice; // This is the price for ONE set
    const roundedPricePerSet = Math.ceil(pricePerSet); // Round price per set
    const subtotalPrice = roundedPricePerSet * qty; // Calculate subtotal using rounded price

    // Update display
    document.getElementById("blinds-size-row").style.display = "block";
    document.getElementById("blinds-size").textContent = formatSizeDisplay(width, height, commonUnit);
    document.getElementById("blinds-sqft").textContent = calculatedSqft.toFixed(2);
    document.getElementById("blinds-total").textContent = roundedPricePerSet.toFixed(2); // Price per set
    document.getElementById("blinds-subtotal").textContent = subtotalPrice.toFixed(2); // Subtotal for all sets
    
    // Update conversion display
    updateConversionDisplay();
    
    // Toggle minimum order notice
    toggleMinOrderNotice(calculatedSqft);
  }

  // Validation function
  function validateBlindsFields() {
    let isValid = true;
    const customType = document.getElementById("custom-type").value;
    
    let widthInput, heightInput, errorEl;
    
    if (customType === "inside") {
        widthInput = document.getElementById("inside-width");
        heightInput = document.getElementById("inside-height");
        errorEl = document.getElementById("inside-error");
    } else {
        widthInput = document.getElementById("outside-width");
        heightInput = document.getElementById("outside-height");
        errorEl = document.getElementById("outside-error");
    }
    
    // Reset error message
    if (errorEl) {
        errorEl.textContent = '';
        errorEl.style.display = 'none';
    }
    
    // Check if fields are filled
    if (!widthInput.value || !heightInput.value) {
        if (errorEl) {
        errorEl.textContent = 'Please fill in all dimensions';
        errorEl.style.display = 'block';
        errorEl.style.fontSize = "1.3rem";
        }
        isValid = false;
    }
    
    // Check for valid positive numbers
    const width = parseFloat(widthInput.value) || 0;
    const height = parseFloat(heightInput.value) || 0;
    
    // Get current unit for conversion
    const commonUnit = document.getElementById("common-unit").value;
    
    // Convert to feet for validation
    const widthFt = convertToFeet(width, commonUnit);
    const heightFt = convertToFeet(height, commonUnit);
    
    // Set minimum requirements
    const minWidthFt = 1; // Minimum width: 1ft
    const minHeightFt = 2; // Minimum height: 2ft
    
    if (widthFt < minWidthFt) {
        if (errorEl) {
        errorEl.textContent = `Minimum width is ${minWidthFt}ft (${minWidthFt * 30.48}cm / ${minWidthFt * 12}inch)`;
        errorEl.style.display = 'block';
        errorEl.style.fontSize = "1.3rem";
        }
        isValid = false;
    }
    
    if (heightFt < minHeightFt) {
        if (errorEl) {
        errorEl.textContent = `Minimum height is ${minHeightFt}ft (${minHeightFt * 30.48}cm / ${minHeightFt * 12}inch)`;
        errorEl.style.display = 'block';
        errorEl.style.fontSize = "1.3rem";
        }
        isValid = false;
    }
    
    return isValid;
  }

  // Event listeners for all inputs that trigger calculation
  const inputsToWatch = [
    "inside-width", "inside-height", 
    "outside-width", "outside-height",
    "blinds-qty", "common-unit"
  ];
  
  inputsToWatch.forEach(inputId => {
    const el = document.getElementById(inputId);
    if (el) {
      el.addEventListener("input", calculateBlinds);
      if (el.tagName === 'SELECT') {
        el.addEventListener("change", calculateBlinds);
      }
    }
  });

  // For plus/minus UI buttons
  document.querySelectorAll('.quantity__button').forEach(btn => {
    btn.addEventListener('click', function () {
      setTimeout(calculateBlinds, 50);
    });
  });

  // Observe price changes if the base price element changes
  const basePriceEl = document.querySelector('[data-product-price]') || document.querySelector('.price-item--regular');
  if (basePriceEl) {
    const observer = new MutationObserver(() => {
      calculateBlinds();
    });
    observer.observe(basePriceEl, { childList: true, subtree: true });
  }

  // Add-to-Quotation logic - FIXED
  function addItemToCart(item) {
    let customCart = JSON.parse(localStorage.getItem("customCart")) || [];

    const idx = customCart.findIndex(ci =>
      ci.productName === item.productName &&
      ci.selectedVariant === item.selectedVariant &&
      (ci.mountType || '') === (item.mountType || '') &&
      (ci.cordLocation || 'Right') === (item.cordLocation || 'Right') &&
      (ci.message || '') === (item.message || '')
    );

    if (idx > -1) {
      // Update existing item - FIXED: Recalculate total price based on new quantity
      const newQty = (parseInt(customCart[idx].qty) || 1) + (parseInt(item.qty) || 1);
      customCart[idx].qty = newQty;
      customCart[idx].totalPrice = customCart[idx].unitPrice * newQty;
    } else {
      // Add new item - FIXED: Ensure unitPrice and totalPrice are correct
      item.qty = parseInt(item.qty) || 1;
      item.unitPrice = parseFloat(item.unitPrice) || 0;
      item.totalPrice = item.unitPrice * item.qty; // Ensure totalPrice is calculated correctly
      customCart.push(item);
    }

    localStorage.setItem("customCart", JSON.stringify(customCart));
  }

  // Handle Add to Quotation - SINGLE CORRECT VERSION
  function handleAddToQuotation() {
    // Check the live Shopify variant only when the customer tries to proceed.
    if (!selectedVariantIsAvailable()) {
      setVariantError('The selected variant is out of stock or unavailable. Please choose an available variant before adding it to your quotation.');
      return;
    }

    setVariantError('');

    // Collect current selection
    const productName = document.getElementById('product-name')?.value || '';
    const variantDesc = getVariantDescription();
    const customType = document.getElementById("custom-type").value;
    const qtyVal = parseInt(document.getElementById('blinds-qty')?.value || 1);
    let message = document.getElementById('message')?.value || '';
    const cordLocation = document.getElementById('cord-location')?.value || 'Right';
    const currency = getCurrencySymbol();
    const commonUnit = document.getElementById("common-unit").value;

    let widthInput, heightInput, mountType;
    
    if (customType === "inside") {
      widthInput = document.getElementById("inside-width");
      heightInput = document.getElementById("inside-height");
      mountType = "Inside Frame Mount";
    } else {
      widthInput = document.getElementById("outside-width");
      heightInput = document.getElementById("outside-height");
      mountType = "Outside Frame Mount";
    }

    const width = parseFloat(widthInput.value) || 0;
    const height = parseFloat(heightInput.value) || 0;
    const blindsSize = document.getElementById("blinds-size")?.textContent || '';
    
    // Get the CORRECT prices
    const pricePerSet = parseFloat(document.getElementById("blinds-total")?.textContent || '0'); // This is unit price
    const subtotalPrice = parseFloat(document.getElementById("blinds-subtotal")?.textContent || '0'); // This is total

    let variantDetails = '';
    if (variantDesc) {
      variantDetails = `${variantDesc} / ${blindsSize}`;
    } else {
      variantDetails = `${blindsSize}`;
    }

    // Add mount type to message/remark
    if (message) {
      message += ` / ${mountType}`;
    } else {
      message = mountType;
    }

    message += ` / Cord Location: ${cordLocation}`;

    const item = {
      productName,
      selectedVariant: variantDetails,
      mountType,
      cordLocation,
      qty: qtyVal,
      message,
      unitPrice: pricePerSet, // This should be the price per set
      totalPrice: subtotalPrice, // This should be unitPrice * qty
      currency,
      variantImage: document.querySelector(".product__media img")?.src || "",
      productType: "blinds" // ADD THIS LINE to identify blinds products
    };

    addItemToCart(item);

    // Show modal
    const modal = document.getElementById("custom-modal");
    const modalDetails = document.getElementById("modal-details");

    let modalHTML = `
      <strong>${item.productName}</strong><br><br>
      `;

    // Show variant details (without mount type)
    if (item.selectedVariant) {
      modalHTML += `<strong>Variant:</strong> ${item.selectedVariant}<br>`;
    }

    modalHTML += `
      <strong>Quantity:</strong> ${item.qty}<br>
      <strong>Subtotal:</strong> ${item.currency}${item.totalPrice.toFixed(2)}<br>
    `;

    // Only show remark if user entered something
    if (item.message && item.message.trim() !== '') {
      modalHTML += `<strong>Remark:</strong> ${item.message}`;
    }

    modalDetails.innerHTML = modalHTML;
    modal.style.display = "flex";

    // Clear remark field
    document.getElementById('message').value = '';
  }

  // Bind the button
  const btnCustom = document.getElementById("add-to-qt-btn");
  if (btnCustom) {
    btnCustom.addEventListener("click", handleAddToQuotation);
  }

  document.addEventListener('change', function(event) {
    if (event.target.matches('.product-form__input input, [data-option-index] input')) {
      setVariantError('');
    }
  }, true);

  document.addEventListener('click', function(event) {
    const variantLabel = event.target.closest('.product-form__input label, [data-option-index] label');
    if (variantLabel) setVariantError('');
  }, true);

  document.addEventListener('variant:change', function() { setVariantError(''); });
  document.addEventListener('variant-change', function() { setVariantError(''); });

  // OK button to close modal
  const okBtn = document.getElementById("modal-ok-btn");
  if (okBtn) {
    okBtn.addEventListener("click", function () {
      const modal = document.getElementById("custom-modal");
      modal.style.display = "none";
    });
  }

  // Initial calculation
  calculateBlinds();
  syncCalculatorVisibility();
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initCustomBlindsCalculator, { once: true });
} else {
  initCustomBlindsCalculator();
}
